module.exports = __webpack_public_path__ + "img/bir-pletok.0c71844e.jpg";